// Scroll targets (react-scroll ids) and their display labels, in page order.
export const navLinks = [
  { to: 'home', label: 'Home' },
  { to: 'about', label: 'About' },
  { to: 'summary', label: 'Summary' },
  { to: 'experience', label: 'Experience' },
  { to: 'projects', label: 'Projects' },
  { to: 'ai', label: 'How I work' },
  { to: 'drones', label: 'Drones' },
  { to: 'contact', label: 'Contact' },
];

// The gallery is a separate page (its own route), not an in-page section, so it
// is not part of navLinks above. It renders last in the nav with an external
// arrow so it reads as leaving the landing page.
export const galleryNav = {
  to: '/gallery',
  label: 'Drone Gallery',
};
